<template>
  <i data-testid="spinner" class="spinner fal fa-sync" />
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style lang="scss">
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spinner {
  animation: spin 4s linear infinite;
}
</style>
